import {name, components, mixins, props, data} from './config'

export default {
    name,
    components,
    mixins,
    props,
    data() {
        return {
            ...data,
            innerValue: this.value
        }
    },
    watch: {
        innerValue: {
            handler(val) {
                this.updateTimeDisplay(val)
                this.$emit('input', val)
            },
            deep: true,
            immediate: true
        }
    },
}
